import React from "react"
import { Link } from "gatsby"

const Swiper = ({ children, to, back }) => {
    if (to) {
        return <Link to={to}>{children}</Link>
    }
    return <div>{children}</div>
}

export default Swiper
